import { onboardingQueryKeys as e } from "./useOnboardingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { onboardingApi as n } from "@maat/api-main";
//#region src/onboarding/useOnboardingStatusQuery.ts
var r = (r = !0) => t({
	queryKey: e.status(),
	queryFn: n.getStatus,
	enabled: r
});
//#endregion
export { r as useOnboardingStatusQuery };
